import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import { Box, Card, CardContent, Chip, Stack, Typography } from "@mui/material";

interface PurchaseTrendProps {
  data: Array<{ month: string; bills: number; purchaseCost: number }>;
}

const formatCurrency = (value: number) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(value);

const PurchaseTrend = ({ data }: PurchaseTrendProps) => {
  const rows = data.slice(-6);
  const max = Math.max(...rows.map((row) => row.purchaseCost), 1);

  return (
    <Card elevation={0} sx={(theme) => ({ borderRadius: 2, border: "1px solid", borderColor: theme.palette.mode === "dark" ? "#2a3953" : "divider", bgcolor: theme.palette.mode === "dark" ? "#111b2d" : "background.paper", height: 280, overflow: "hidden" })}>
      <CardContent sx={{ height: "100%", p: { xs: 1.5, md: 1.75 }, "&:last-child": { pb: { xs: 1.5, md: 1.75 } } }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1.5}>
          <Stack direction="row" spacing={1.25} alignItems="center">
            <Box sx={{ width: 38, height: 38, display: "grid", placeItems: "center", borderRadius: 2, bgcolor: "primary.light", color: "primary.dark" }}>
              <ShoppingBagOutlinedIcon fontSize="small" />
            </Box>
            <Box>
              <Typography variant="h6" fontWeight={800}>Purchase Trend</Typography>
              <Typography variant="caption" color="text.secondary">Recorded purchase cost by period, not stock valuation</Typography>
            </Box>
          </Stack>
          <Chip label="Last 6 months" variant="outlined" size="small" />
        </Stack>

        {rows.length === 0 ? (
          <Typography color="text.secondary">No purchase data available yet.</Typography>
        ) : (
          <Stack direction="row" spacing={{ xs: 1, sm: 2 }} alignItems="flex-end" sx={{ height: 174, px: { xs: 0.5, md: 1 }, borderBottom: "1px solid", borderColor: "divider" }}>
            {rows.map((row) => (
              <Box key={row.month} sx={{ height: "100%", flex: 1, minWidth: 0, display: "flex", flexDirection: "column", justifyContent: "flex-end", alignItems: "center", gap: 0.85 }}>
                <Typography variant="caption" fontWeight={800} color="primary.main" sx={{ whiteSpace: "nowrap", fontSize: { xs: "0.58rem", sm: "0.68rem" } }}>
                  {formatCurrency(row.purchaseCost)}
                </Typography>
                <Box sx={{ width: "min(56px, 76%)", height: `${Math.max((row.purchaseCost / max) * 112, 8)}px`, borderRadius: "8px 8px 2px 2px", background: "linear-gradient(180deg, #60A5FA 0%, #2563EB 100%)", boxShadow: "0 8px 16px rgba(37,99,235,.18)" }} />
                <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "100%" }}>
                  {row.month}
                </Typography>
              </Box>
            ))}
          </Stack>
        )}
      </CardContent>
    </Card>
  );
};

export default PurchaseTrend;
